import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

/**
 * @description
 * MuiBackdrop overrides
 * @param {Object} theme - The theme object
 * @returns {Object} MuiBackdrop overrides
 */
export default function Backdrop(theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[800], 0.8),
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
